import styled from 'styled-components'
import {
  CORRECT_COLOR,
  INCORRECT_COLOR,
} from '~/pages/anatomyV2/libs/components/DiagnosisQuestionTemplate/constants'
import { OptionButton } from '~/pages/anatomyV2/libs/optionButtonStyles'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const DiagnosisQuestionTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0 16px;
  `,

  CaseBoxWrapper: styled.div`
    position: relative;
    margin-bottom: 32px;
  `,

  CaseBox: styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background: ${COLORS.GRAY_100};
    padding: 16px 124px 16px 16px;
  `,

  CaseText: styled.p`
    color: ${COLORS.BLACK};
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
  `,

  Illustration: styled.img`
    position: absolute;
    z-index: 2;
    top: -60px;
    left: 0px;
    height: 358px;
  `,

  Options: styled.div`
    position: relative;
    z-index: 3;
    margin-top: auto;
    background-color: ${COLORS.GRAY_100};
  `,

  OptionButton,

  ResultBody: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,

  ResultHeader: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  `,

  ResultTitle: styled.p<{ $isCorrect: boolean }>`
    font-family: 'Mulish', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: ${({ $isCorrect }) =>
      $isCorrect ? CORRECT_COLOR : INCORRECT_COLOR};
  `,

  ResultExplanation: styled.p`
    color: #7d7d7d;
    font-family: 'Mulish', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
  `,

  StyledButton: styled(Button)`
    position: relative;
    z-index: 3;
    width: 100%;
    margin-top: auto;
  `,
}
